module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"insertName":"Full Name","insertMail":"Email address"},"it":{"insertName":"Nome","insertMail":"Indirizzo email"}}')
  delete Component.options._Ctor
}
